module.exports = __webpack_public_path__ + "media/images/emblems/Surpierre-coat_of_arms-1f1e2859ee58347ff60abdc596db5b31.svg";